const Production = require('./production');
const Localhost = require('./localhost');
const Staging = require('./staging');
const Alpha = require('./alpha');
const Sandbox = require('./sandbox');
const SandboxDev = require('./sandbox-dev');
const SandboxDevLocal = require('./sandbox-dev-local');

const config = {
    production: Production,
    staging: Staging,
    localhost: Localhost,
    alpha: Alpha,
    sandbox: Sandbox,
    'sandbox-dev': SandboxDev,
    'sandbox-dev-local': SandboxDevLocal,
};

// get app environment
const env = process.env.REACT_APP_BUILD_ENV || '';
const configFile = config[env] || '';

// export config file
module.exports = configFile;
